import { cqrs } from '@faro/http-clients';
import { AssessmentMeasurementSystemOption, toAssessmentMeasurementSystemOption } from '@faro/study-designer-model';

export const assessmentMeasurementSystemOptionsClient = cqrs<AssessmentMeasurementSystemOption>(
    '/api/study-designer/assessment-measurements/:id/system-options',
    toAssessmentMeasurementSystemOption
).readableEntityClient();
